import { render } from "./bmedit.vue?vue&type=template&id=ec260c0c&scoped=true"
import script from "./bmedit.vue?vue&type=script&lang=js"
export * from "./bmedit.vue?vue&type=script&lang=js"

import "./bmedit.vue?vue&type=style&index=0&id=ec260c0c&lang=scss&scoped=true"
import "./bmedit.vue?vue&type=style&index=1&id=ec260c0c&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec260c0c"]])

export default __exports__